import { render, staticRenderFns } from "./DigitalFormDetail.vue?vue&type=template&id=6f8da96a&scoped=true&"
import script from "./DigitalFormDetail.vue?vue&type=script&lang=js&"
export * from "./DigitalFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./DigitalFormDetail.vue?vue&type=style&index=0&id=6f8da96a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8da96a",
  null
  
)

export default component.exports